import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSServiceError } from "../../utils/serviceHelper";
import { getPlanEnrollment } from "../../services/api/planEnrollment/getPlanEnrollment";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;

export const QUERY_BENEFITS_PLAN_ENROLLMENT = "QUERY_BENEFITS_PLAN_ENROLLMENT";

export const useQueryPlanEnrollment = (
  planEnrollmentId: string,
  config?: WSQueryConfig<IPlanEnrollment, WSServiceError>
) =>
  useWSQuery(
    [QUERY_BENEFITS_PLAN_ENROLLMENT, planEnrollmentId],
    () => getPlanEnrollment(planEnrollmentId),
    config
  );
